/// <amd-module name="Widgets/TeamMembersWidget/components/TeamMembersSettings" />
import { TeamWidgetSettings } from "WidgetCommon/ConfigContracts/TeamWidgetSettings";

export interface TeamMembersSettings extends TeamWidgetSettings {}
